import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { DateFormatter } from '@repo/toolkit/date'
import Box from '@repo/ui/box'
import Typography from '@repo/ui/typography'

import useTranslate from '../../../../lib/hooks/use-translate'
import { Center } from '../../../../lib/types/models/center/center'
import { JourneyProperties } from '../../../../lib/types/models/product/journey.properties'
import { getTranslatedName } from '../../../../lib/utils/functions/translation.functions'
import PeriodBadge from '../../../elements/period-badge'

type Props = {
  center: Center
}
const OlCenterJourneyBadgeDetails = ({ center }: Props) => {
  const { t, currentLanguage } = useTranslate()

  return (
    <Box className="bg-white-hover border border-grey-light rounded-lg">
      <Typography variant="text" color={tailwindColors.grey.DEFAULT}>
        {t('ol.center.journey.badge.title')}
      </Typography>
      <div className="flex items-center gap-2 flex-wrap">
        {center.centerToJourneys.map((centerToJourney) => {
          const journey = centerToJourney.journey
          const secondaryOptions = journey.secondaryOptions
            .map(
              (secondaryOption) =>
                getTranslatedName(secondaryOption.option, currentLanguage) || '—'
            )
            .join(' , ')

          const formula = getTranslatedName(journey.date.product.formula, currentLanguage) || '—'
          const mainOption = getTranslatedName(journey.mainOption, currentLanguage) || '—'

          return (
            <PeriodBadge
              key={centerToJourney.id}
              period={journey.date.period}
              className="mt-2"
              text={`${JourneyProperties.getJourneyLabel(journey)} - ${DateFormatter.DDMMYYYY(journey.date.departureDate)} ${t('common.to')} ${DateFormatter.DDMMYYYY(journey.date.returnDate)} - ${formula} - ${mainOption}${secondaryOptions ? ` - ${secondaryOptions}` : ''} - ${journey.date.durationInDays} ${t('common.days')}`}
            />
          )
        })}
      </div>
    </Box>
  )
}

export default OlCenterJourneyBadgeDetails
